import React from 'react';

export interface Teacher {
    id: number;
    name: string;
    university: string;
    major: string;
    languages: string[];
    image: string;
    rating: number;
    reviews: number;
}

interface TeacherCardProps {
    teacher: Teacher;
    selected: boolean;
    onClick: () => void;
    disabled?: boolean;
}

const TeacherCard: React.FC<TeacherCardProps> = ({
    teacher,
    selected,
    onClick,
    disabled = false
}) => {
    return (
        <div
            className={`teacher-card ${selected ? 'selected' : ''}`}
            onClick={() => !disabled && onClick()}
        >
            <div className="teacher-image">
                <img src={teacher.image} alt={teacher.name} />
            </div>
            <div className="teacher-details">
                <h3>{teacher.name}</h3>
                <p className="university">{teacher.university}</p>
                <p className="major">{teacher.major}</p>
                <div className="rating">
                    <span className="stars">{'★'.repeat(Math.floor(teacher.rating))}</span>
                    <span className="rating-value">{teacher.rating}</span>
                    <span className="reviews">({teacher.reviews} ulasan)</span>
                </div>
                <div className="languages">
                    {teacher.languages.map((lang, idx) => (
                        <span key={idx} className="language-tag">{lang}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TeacherCard;